/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState, useEffect } from "react";

// @mui material components
import Container from "@mui/material/Container";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";

// Soft UI Dashboard PRO React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

// Pricing page components
import PricingCards from "layouts/pages/pricing-page/components/PricingCards";
import Faq from "layouts/pages/pricing-page/components/Faq";
import Bundles from "layouts/pages/pricing-page/components/Bundles";
import SoftTypography from "components/SoftTypography";
import ViewListOutlinedIcon from "@mui/icons-material/ViewListOutlined";
import useAuth from "layouts/authentication/hooks/useAuth";
import { useLocation } from "react-router-dom";
import { Alert, CircularProgress } from "@mui/material";
import { axiosPrivate } from "layouts/authentication/api/axios";
import { CheckCircle } from "@mui/icons-material";

function PricingPage() {
  const { auth } = useAuth();
  const location = useLocation();

  const [isLoading, setIsLoading] = useState(false);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [currentPlandID, setCurrentPlandID] = useState(auth?.plan?.id ?? auth?.access_token ? 1 : 0);

  useEffect(() => {
    const isProcessingSubscriptionStatus = new URLSearchParams(location.search).has("processing");
    const tentativeSubscriptionStatus = new URLSearchParams(location.search).get("state");
    const hostedPageID = new URLSearchParams(location.search).get("id");

    if (isProcessingSubscriptionStatus) {
      // check for status, 10 times and show message if failed
      if (tentativeSubscriptionStatus === "succeeded") {
        setIsLoading(true);
        
        axiosPrivate
          .get("/chargebee/checkout/hosted_page/" + hostedPageID, {
            withCredentials: true,
          })
          .then((res) => {
            if (res.data.hosted_page?.status) {
              setCurrentPlandID(2);
              setShowSuccessMessage(true);
            }
          }).finally(() => {
            setIsLoading(false);
          });
      }
    }
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox py={3}>
        <SoftBox mb={3}>
          <Container>
            {isLoading && (
              <SoftBox px={{ display: "flex", justifyContent: "center" }}>
                <CircularProgress color="inherit" />
              </SoftBox>
            )}
            {showSuccessMessage && (
              <Alert icon={<CheckCircle fontSize="inherit" />} severity="success">
                Thank You! Your subscription has been successfully created.
              </Alert>
            )}
            <PricingCards
              currentPlanID={currentPlandID}
              currentPlanLevel={auth && auth.plan ? auth.plan.level : auth && auth.access_token ? 1 : 0}
            />
          </Container>
          {/* <SoftBox mt={5}>
            <SoftBox
              sx={{
                background: "rgba(103, 116, 142, 0.2)",
                borderRadius: "20px",
                color: "#7E8BA9",
                justifyContent: "center",
              }}
            >
              <SoftBox p={3} sx={{ width: "100%" }} display="flex" justifyContent="center" alignItems="center" gap={1}>
                <ViewListOutlinedIcon fontSize="medium" color="inherit" />
                <SoftTypography variant="body2" color="inherit" sx={{ textTransform: "uppercase", cursor: "pointer" }}>
                  Investment Bundles
                </SoftTypography>
              </SoftBox>
            </SoftBox>
            <SoftBox py={3}>
              <Bundles />
            </SoftBox>
          </SoftBox> */}
          <Container>
            <Faq />
          </Container>
        </SoftBox>
      </SoftBox>
      <Footer />
    </DashboardLayout>
  );
}

export default PricingPage;
